module.exports = __webpack_public_path__ + "static/media/stock_in_32_blue.8f01c319.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/stock_in_32_blue.svg
// module id = 1106
// module chunks = 0